import  React from 'react';

/* import share controls hook*/
import useShareControls from './shareControl.hook';

/* import components */
import Information from '../global/Information';
import CmsCheckbox from '../global/CmsCheckBox';
import CopyField from '../global/CopyField';

import "../../../css/content/shareControls.scss";

const ShareControls = ({shareEnabled, shareLink, externalShareType} : {shareEnabled: boolean, shareLink: string, externalShareType: any}) => {

    const {isShareEnabled, sharelink, isExternalSharingEnabled, handleShareEnabled, handleExternalSharing} = useShareControls({shareLink, shareEnabled, externalShareType})

    return <div className='share-controls-container'>
        <h2 className='share-controls-header'>
            Sharing Options
        </h2>

        <CmsCheckbox 
            id={'SharingEnabled-react'}
            isChecked={isShareEnabled}
            handleChange={handleShareEnabled}
            labelText={'Create Public Share Link'}
        />
     
        {isShareEnabled && 
            <>   
                {sharelink
                    ? <CopyField 
                        text={sharelink}
                        successMessage='Copied URL to clipboard'
                        failMessage='Unable to copy URL to clipboard. Please try again.'
                        tooltip='Copy to clipboard'
                        tooltipId='copy-sharelink-to-clipboard-tooltip'
                    />
                    : <Information style={{}} text={'Save and Publish this item to create your shareable URL'}/>
                }
                
                <CmsCheckbox 
                    id={'allow-external-sharing'}
                    isChecked={isExternalSharingEnabled}
                    handleChange={handleExternalSharing}
                    labelText={'Allow External Sharing'}
                />
            </>        
        }
        
    </div>
}

export default ShareControls